import { render, staticRenderFns } from "./GroupDetailsDisplay.vue?vue&type=template&id=5690cd3f&"
import script from "./GroupDetailsDisplay.vue?vue&type=script&lang=js&"
export * from "./GroupDetailsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports